import { TIP3TokenService } from './TIP3Tokens';

export { TIP3TokenService };
